<div [attr.dir]="translate.currentLang === 'ar' ? 'rtl' : 'ltr'" class="summary-container">
  <div class="summary-header d-flex justify-content-between align-items-center">
    <h2 class="title">{{ titleKey | translate }}</h2>
    <button class="close-button" (click)="dialogRef.close(false)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="banner">
    <img src="assets/img/paysummary.png" alt="Summary" class="banner-image">
    <div class="banner-text mx-2">
      <h3 class="banner-title text-start">{{ subtitleKey | translate }}</h3>
    </div>
  </div>
  <div class="row  summary-details mb-3 mx-0">
    <div *ngFor="let item of details"  [ngClass]="{'detail-item col-md-6 col-lg-4 col-xl-4 col-sm-12 col-xs-12': item.value}">
      <div  *ngIf="item.value">
        <div class="d-flex flex-row align-items-center justify-content-start">
          <span  class="icon d-flex justify-content-start ">
            <mat-icon *ngIf="item.icon.startsWith('mat-')">{{ item.icon.replace('mat-', '') }}</mat-icon>
            <span *ngIf="!item.icon.startsWith('mat-')">{{ item.icon }}</span>
          </span>
          <span class="label mx-2">{{ item.labelKey | translate }}</span>
        </div>
        <div  class="text-start">
          <span class="text-color-theme" [ngClass]="{'font-small':item.labelKey == 'IBAN'}">{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
  <!-- <div #swipeContainer class="swipe-container"
  [ngClass]="{'justify-content-start': translate.currentLang == 'en', 'justify-content-end': translate.currentLang != 'en'}">
<div class="swipe-button"
    [ngStyle]="{'transform': 'translateX(' + position + 'px)'}"
    (mousedown)="startDrag($event)"
    (mousemove)="drag($event)"
    (mouseup)="endDrag()"
    (mouseleave)="endDrag()"
    (touchstart)="startDrag($event)"
    (touchmove)="drag($event)"
    (touchend)="endDrag()">
 <img draggable="false" *ngIf="!confirmed" src="assets/img/Swipe.svg" alt="Swipe Icon" width="24" height="24">
</div>
</div> -->

        <button
          (click)="submit()"
          class="btn btn-primary"
          type="submit">
          {{ "submit" | translate }}
        </button>
              <button
          (click)="cancel()"
          class="btn btn-danger mx-2"

        >
          <!-- <span
          *ngIf="!confirmed"
            class="spinner-border spinner-border-sm"
          ></span> -->
          {{ "cancel" | translate }}
        </button>

  <span class="confirmation" *ngIf="confirmed">✅ {{ 'confirmed' | translate }}</span>
</div>
